import React from 'react';

const pulse = {
  animation: 'skeletonPulse 1.5s ease-in-out infinite',
  background: 'var(--c-surface-elevated, #f5f3f0)',
  borderRadius: 8,
};

// Inject keyframes once
if (typeof document !== 'undefined' && !document.getElementById('skeleton-pulse-style')) {
  const style = document.createElement('style');
  style.id = 'skeleton-pulse-style';
  style.textContent = `
    @keyframes skeletonPulse {
      0%, 100% { opacity: 0.4; }
      50% { opacity: 1; }
    }
  `;
  document.head.appendChild(style);
}

export const Bone = ({ width, height = 14, radius, circle, style: extra, ...props }) => {
  const r = circle ? '50%' : (radius ?? 8);
  const w = circle ? height : width;
  return (
    <div
      style={{ ...pulse, width: w, height, borderRadius: r, flexShrink: 0, ...extra }}
      {...props}
    />
  );
};

export const Card = ({ children, style: extra, ...props }) => (
  <div
    style={{
      background: 'var(--c-surface-card, #fff)',
      border: '1px solid var(--c-border, #e0ddd6)',
      borderRadius: 20,
      padding: '20px',
      ...extra,
    }}
    {...props}
  >
    {children}
  </div>
);

export const Row = ({ gap = 12, align = 'center', children, style: extra }) => (
  <div style={{ display: 'flex', alignItems: align, gap, ...extra }}>{children}</div>
);

export const Col = ({ gap = 10, children, style: extra }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap, ...extra }}>{children}</div>
);

export const Container = ({ children, style: extra }) => (
  <div
    style={{
      maxWidth: 'clamp(390px, 70vw, 560px)',
      margin: '0 auto',
      padding: '0 16px',
      ...extra,
    }}
  >
    {children}
  </div>
);
